module.exports = __webpack_public_path__ + "media/video_2.62e49274.mp4";